<template>
  <div class="internal-page-slides">
    <div
        v-for="(slide, index) of slidesArray"
        :key="index"
        class="internal-page-slide"
        :style="!slide.fields.posizionamentoDelContenuto ? `background-image: url(${bgImage}); background-size: 100% 100%` : ''">
        <InternalTitleDescriptionImageParallax
            :images="slide.fields.images"
            :contents="slide.fields.contents"
            :contentLeft="slide.fields.posizionamentoDelContenuto"
            :rellaxSpeed="rellaxSpeed"/>
        </div>
    </div>
</template>

<script>
import InternalTitleDescriptionImageParallax from '@/components/InternalTitleDescriptionImageParallax/InternalTitleDescriptionImageParallax.vue'
import matchMedia from '@/mixins/matchMedia.js'

export default {
  name: 'InternalPageSlides',
  mixins: [matchMedia],
  components: {
    InternalTitleDescriptionImageParallax,
  },
  props: {
    slidesArray: {
      type: Array,
      default: undefined
    },
    bgImage: {
      type: String,
      default: undefined
    }
  },
  computed: {
    rellaxSpeed: {
      get () {
        if (typeof this.matchMedia !== undefined && this.matchMedia === 'small') return 0
        if (typeof this.matchMedia !== undefined && this.matchMedia === 'medium') return -3
        return -2
      }
    }
  }
}
</script>

<style lang="scss">
  @import "./internalPageSlides.scss";
</style>
  